import { render } from "./index.vue?vue&type=template&id=b0f374ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b0f374ca&lang=scss&scoped=true"

import exportComponent from "../../../../ag-v3-system/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f374ca"]])

export default __exports__